import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {getOrder} from '../actions/placed-order'
import {sendRsvp} from '../actions/rsvp'

export const calendarLinks = createReducer(null, builder => {
  builder.addMatcher(isAnyOf(sendRsvp.fulfilled, getOrder.fulfilled), (_, action) => {
    return {
      ...action.payload.calendarLinks,
    }
  })
})
